import {
  GetSnapshot,
  PostSnapshotByPeriodo,
  PutSnapshotEvaluacion,
  DeleteSnapshotEvaluacion,
  GetResumen,
  PutCambiarVendedor,
  GetTiposMembresiaOpciones,
  State as ComisionMembresiaState
} from "../../../reducers/comisionMembresia";

export interface SnapshotStore
  extends GetSnapshot,
    PostSnapshotByPeriodo,
    PutSnapshotEvaluacion,
    DeleteSnapshotEvaluacion,
    GetResumen,
    PutCambiarVendedor,
    GetTiposMembresiaOpciones {}

export const snapshotStore: (state) => SnapshotStore = state => {
  const comisionMembresia: ComisionMembresiaState = state.comisionMembresia;

  return {
    snapshot: comisionMembresia.snapshot,
    gettingSnapshot: comisionMembresia.gettingSnapshot,
    gettingSnapshotError: comisionMembresia.gettingSnapshotError,

    postSnapshotResult: comisionMembresia.postSnapshotResult,
    postingSnapshotByPeriodo: comisionMembresia.postingSnapshotByPeriodo,
    postingSnapshotByPeriodoError:
      comisionMembresia.postingSnapshotByPeriodoError,

    putSnapshotEvaluacionResult: comisionMembresia.putSnapshotEvaluacionResult,
    puttingSnapshotEvaluacion: comisionMembresia.puttingSnapshotEvaluacion,
    puttingSnapshotEvaluacionError:
      comisionMembresia.puttingSnapshotEvaluacionError,

    deleteSnapshotEvaluacionResult:
      comisionMembresia.deleteSnapshotEvaluacionResult,
    deletingSnapshotEvaluacion: comisionMembresia.deletingSnapshotEvaluacion,
    deletingSnapshotEvaluacionError:
      comisionMembresia.deletingSnapshotEvaluacionError,

    resumenSnapshot: comisionMembresia.resumenSnapshot,
    gettingResumenSnapshot: comisionMembresia.gettingResumenSnapshot,
    gettingResumenSnapshotError: comisionMembresia.gettingResumenSnapshotError,

    cambiarVendedorResult: comisionMembresia.cambiarVendedorResult,
    puttingCambiarVendedor: comisionMembresia.puttingCambiarVendedor,
    puttingCambiarVendedorError: comisionMembresia.puttingCambiarVendedorError,

    tiposMembresiaOpciones: comisionMembresia.tiposMembresiaOpciones,
    gettingTiposMembresiaOpciones:
      comisionMembresia.gettingTiposMembresiaOpciones,
    gettingTiposMembresiaOpcionesError:
      comisionMembresia.gettingTiposMembresiaOpcionesError
  };
};
